const reg = {
  // 护照号
  passport: /^([A-Z,0-9]{5,20})$/,
  // 身高
  height: /^\d{1,3}$/,
  // 体重
  weight: /^\d{1,3}$/,
  // 邮编
  postcode: /^[0-9]{6}$/,
  // 传真
  // fax: /^((\d{3,5})|(\d{3,5}-))?\d{7,10}$/,
  // 邮箱
  email: /^[0-9,a-z,A-Z,\!\#\*\&\%\.\_]+@[0-9,a-z,A-Z]+\.[0-9,a-z,A-Z]+$/,
  // 姓氏
  family_name_spell: /^[a-zA-Z]+$/,
  // 名字
  given_name_spell: /^[a-zA-Z]+$/,
};
export default {
  data() {
    /*// 外语
    const checkValidate = (idx, callback) => {
      const language_row = this.vitaForm.language_row[idx];
      let {entries} = Object;
      for(let [key, val] of entries(language_row)) {
        if(val) {
          callback();
        } else {
          this.$refs['vitaForm'].validateField("language_row."+idx+"."+ key);
        }
      }
    };
    const languageValidate = (rule, value, callback, index) => {
      // console.log(rule);
      if(value) {
        checkValidate(index, callback);
      } else {
        callback(new Error("请选择语种"));
      }
    };
    const spokenValidate = (rule, value, callback, index) => {
      // console.log(rule);
      if(value) {
        checkValidate(index, callback);
      } else {
        callback(new Error("请选择口语熟练度"));
      }
    };
    const writtenValidate = (rule, value, callback, index) => {
      // console.log(rule);
      if(value) {
        checkValidate(index, callback);
      } else {
        callback(new Error("请选择书写熟练度"));
      }
    };*/
    return {
      /*languageValidate,
      spokenValidate,
      writtenValidate,*/
      rules: {
        // 姓名
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          /*{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }*/
        ],
        // 姓氏
        family_name_spell: [
          {required: true,
            validator: (rule, value, callback) => {
              let msg='请输入拼音大写,例如张三,输入:ZHANG';
              this.switch_pinyin && (msg='姓名不区分姓氏和名的少数民族讲师填写,例如巴桑次仁,输入：BASANGCIREN');
              if (!value) {
                callback(new Error(msg));
              } else {
                reg.family_name_spell.test(value)
                  ? callback()
                  : callback(new Error(msg));
              }
            },
            trigger: 'change'},
          /*{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }*/
        ],
        // 姓名
        given_name_spell: [
          {required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入名(拼音)大写,例如张三,输入:SAN'))
              } else {
                reg.given_name_spell.test(value)
                  ? callback()
                  : callback(new Error('请输入名(拼音)大写,例如张三,输入:SAN'));
              }
            },
            trigger: 'change'},
          /*{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }*/
        ],
        // 国籍
        nationality: [
          {required: true, message: '请选择国籍', trigger: 'change'},
        ],
        // 民族
        nation: [
          {required: false, message: '请选择民族', trigger: 'change'},
        ],
        // 曾用名
        former_name: [
          {required: false, message: '请选择民族', trigger: 'change'},
        ],
        // 护照号
        passport: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else {
                reg.passport.test(value) ? callback() : callback(new Error('请输入正确的护照号'));
              }
            },
            trigger: "blur",
          }
        ],
        // 性别
        gender: [
          {required: false, message: '请选择性别', trigger: 'change'},
        ],
        // 出生日期，时间戳
        birthday: [
          {required: true, message: '请选择出生日期', trigger: 'change'},
        ],
        // 身高，（cm）应该为纯数字
        height: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('身高不能为空'));
              } else {
                reg.height.test(value)
                  ? callback()
                  : callback(new Error('请输入正确身高(单位/cm) 例如:180'));
              }
            },
            trigger: "blur",
          }
        ],
        // 体重，（kg）保留一位小数
        weight: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('体重不能为空'));
              } else {
                reg.weight.test(value)
                  ? callback()
                  : callback(new Error('请输入体重(单位/kg) 例如:65'));
              }
            },
            trigger: "blur",
          }
        ],
        // 邮箱地址
        email_address: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else {
                if(this.emailErr) {
                  callback(new Error(this.emailMsg));
                  this.emailErr = false;
                } else {
                  reg.email.test(value)
                    ? callback()
                    : callback(new Error('请输入正确的邮箱'));
                }
              }
            },
            trigger: "change",
          }
        ],
        // 个人联系电话，可以是座机、手机
        contact_numbers: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else {
                this.$yioks.phone(value) ? callback() : callback(new Error('请输入正确的联系电话'));
              }
            },
            trigger: "blur",
          }
        ],
        // 个人邮编
        postcode: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else {
                reg.postcode.test(value) ? callback() : callback(new Error('请输入正确的邮编'));
              }
            },
            trigger: "blur",
          }
        ],
        // 个人传真
        fax_personage: [
          {
            required: false,
            validator: (rule, value, callback) => {
              /*if(!value) {
                callback();
              } else {
                reg.fax.test(value) ? callback() : callback(new Error('请输入正确的传真'));
              }*/
              callback();
            },
            trigger: "blur",
          }
        ],
        // 俱乐部邮编
        club_postcode: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else {
                reg.postcode.test(value) ? callback() : callback(new Error('请输入正确的邮编'));
              }
            },
            trigger: "blur",
          }
        ],
        // 俱乐部电话，可以是座机、手机
        club_telephone: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else {
                this.$yioks.phone(value) ? callback() : callback(new Error('请输入正确的联系电话'));
              }
            },
            trigger: "blur",
          }
        ],
        // 俱乐部传真
        club_fax: [
          {
            required: false,
            validator: (rule, value, callback) => {
              /*if(!value) {
                callback();
              } else {
                reg.fax.test(value) ? callback() : callback(new Error('请输入正确的传真'));
              }*/
              callback();
            },
            trigger: "blur",
          }
        ],
        // 俱乐部邮箱（需要验证格式）
        club_email: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else {
                reg.email.test(value)
                  ? callback()
                  : callback(new Error('请输入正确的邮箱'));
              }
            },
            trigger: "blur",
          }
        ],
        coach_experience:[
          {required: true, message: '请选择执教经历', trigger: 'change'},
        ],
        take_place:[
          {required: true, message: '请选择执教场所', trigger: 'change'},
        ],
        sport_experience:[
          {required: true, message: '请选择运动经历', trigger: 'change'},
        ],
        // 套服尺码
        track_suit: [
          {required: true, message: '请输入套服', trigger: 'change'},
          // {min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur'}
        ],
        // T恤尺码
        polo_T: [
          {required: true, message: '请输入T恤', trigger: 'change'},
          // {min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur'}
        ],
        // 短裤尺码
        shorts: [
          {required: true, message: '请输入短裤', trigger: 'change'},
          // {min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur'}
        ],
        // 跑步鞋号
        track_shoes: [
          {required: true, message: '请输入跑步鞋号', trigger: 'change'},
          // {min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur'}
        ],
        // 执教单位
        take_unit: [
          {required: true, message: '请选择执教单位', trigger: 'change'}
        ],
        // 队伍年龄
        team_age: [
          {required: true, message: '请选择队伍年龄', trigger: 'change'}
        ],
        // 队伍性别
        team_sex: [
          {required: true, message: '请选择队伍性别', trigger: 'change'}
        ],
        // 职务
        take_job: [
          {required: true, message: '请选择职务', trigger: 'change'}
        ],
        // 单位
        take_unit_name: [
          {required: true, message: '请输入单位名称', trigger: 'blur'}
        ],
      },
      emailErr: false,
      emailMsg: "",
    };
  },
};
